import i18n from '../../i18n'
import Currencies from '../../common/constants/currencies'
import getSymbolFromCurrency from 'currency-symbol-map'

export default class CurrencyHelper {
  static getCurrencySymbol (countryCode) {
    return (countryCode == null || countryCode.length == 0) ? Currencies['jp']['symbol'] : getSymbolFromCurrency(Currencies[countryCode]['code'])
  }

  static getCurrencySymbolClass (countryCode) {
    if (countryCode == null || Currencies[countryCode] == null) {
      return Currencies['jp']['css_class']
    }

    return Currencies[countryCode]['css_class']
  }

  static getCurrencyCode (countryCode) {
    if (countryCode == null || Currencies[countryCode] == null) {
      return Currencies['jp']['code']
    }

    return Currencies[countryCode]['code']
  }

  static getCurrencySymbolForValidation (countryCode) {
    if (countryCode == 'jp') {
      return i18n.t('common:currency:jpy')
    }

    var currencyCode = this.getCurrencyCode(countryCode).toLowerCase()
    return i18n.t('common:currency:' + currencyCode)
  }

  static getExponent(countryCode) {
    if (countryCode == null || Currencies[countryCode] == null) {
      return Currencies['jp']['exponent']
    }

    return Currencies[countryCode]['exponent']
  }

  static getExponentByCurrencyCode(currencyCode) {
    var exponent = 0
    Object.values(Currencies).forEach((c) => {
      if (c['code'] === currencyCode) {
        exponent = c['exponent']
      }
    })

    return exponent
  }

  static displayCurrency(){
    return 'JPY'
  }

  static metaCurrencyCode() {
    var meta = document.querySelector('meta[name="currency"]')

    return meta ? meta.content : 'JPY'
  }

  static getSymbolFromSelectedCurrency() {
    return getSymbolFromCurrency(this.metaCurrencyCode())
  }

  static currencyText(lang, currency_code) {
    var textHash = {
      'en': {
        'JPY': 'Japanese Yen',
        'USD': 'America Dollar',
        'AUD': 'Australia Dollar',
        'SGD': 'Singapore Dollar',
        'THB': 'Thai Baht'
      },
      'ja': {
        'JPY': '日本円',
        'USD': 'アメリカドル',
        'AUD': 'オーストラリアドル',
        'SGD': 'シンガポールドル',
        'THB': 'タイバーツ'
      },
      'zh-TW': {
        'JPY': '日元',
        'USD': '美元',
        'AUD': '澳元',
        'SGD': '新加坡元',
        'THB': '泰銖'
      }
    }

    return textHash[lang][currency_code]
  }
}
